<script setup lang="ts">
import type { ResourceItem, StrapiFile } from '@/models'
import { type PropType } from 'vue'
import { useI18n } from 'vue-i18n'

const messages = {}

const { t } = useI18n({ messages })

defineProps({
  resource: {
    type: Object as PropType<ResourceItem>,
    default: () => {},
  },
  isSelected: Boolean,
})

const fileIsImage = (file: StrapiFile) =>
  ['image/jpeg', 'image/gif', 'image/png'].includes(file.mime)
const fileIsVideo = (file: StrapiFile) =>
  ['video/h264', 'video/mp4', 'video/mpeg'].includes(file.mime)
const fileIsAudio = (file: StrapiFile) =>
  ['video/h264', 'video/mp4', 'video/mpeg'].includes(file.mime)
</script>

<template>
  <div class="border-2 border-purple p-4" :class="{ 'border-4 border-yellow': isSelected }">
    <p>
      <span>{{ t('resource') }}</span
      >{{ resource.name }}
    </p>
    <p>{{ resource.description }}</p>
    <div class="flex flex-row">
      <div class="w-24 aspect-square" v-for="file of resource.files" :key="file.id">
        <img v-if="fileIsImage(file)" :src="file.url" alt="" class="rounded-full" />
        <audio v-if="fileIsAudio(file)" controls controlslist="" :src="file.url"></audio>
        <video v-if="fileIsVideo(file)" controls controlslist="" :src="file.url"></video>
      </div>
    </div>
  </div>
</template>
